//src/services/documents.ts
import { api, apiRequest, type DownloadResponse } from "@/lib/apiClient";
import type {
  DocumentFileType,
  DocumentListResponse,
  DocumentStorageSummary,
  DocumentUploadResponse,
} from "@/types/documents";

export type ListDocumentsParams = {
  q?: string;
  file_type?: DocumentFileType;
  limit?: number;
  offset?: number;
};

export async function listDocuments(params: ListDocumentsParams = {}) {
  return api.get<DocumentListResponse>("/documents", {
    params: {
      q: params.q || "",
      file_type: params.file_type || "all",
      limit: params.limit || 30,
      offset: params.offset || 0,
    },
  });
}

export async function getDocumentStorageSummary() {
  return api.get<DocumentStorageSummary>("/documents/storage-summary");
}

export async function uploadDocument(file: File, title: string, description?: string) {
  const form = new FormData();
  form.append("file", file);
  form.append("title", title.trim());
  if (description?.trim()) form.append("description", description.trim());

  return apiRequest<DocumentUploadResponse>(
    "/documents/upload",
    {
      method: "POST",
      body: form,
    },
  );
}

export async function downloadDocument(documentId: string) {
  return api.download(`/documents/${documentId}/download`) as Promise<DownloadResponse>;
}

export async function deleteDocument(documentId: string) {
  return api.delete<{ id: string; deleted: boolean }>(`/documents/${documentId}`);
}
